import {
  AllAssemblyTemplatesForFilterSideBarQuery,
  AllAssemblyTemplatesForFilterSideBarQueryVariables,
  TemplateTypeEnum,
  useAllAssemblyTemplatesForFilterSideBarQuery,
} from '@/__generated__/graphql';
import { allAssemblyTemplates, selectedAssemblyTemplateId } from '@/components/Analysis/state';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { QueryHookOptions } from '@apollo/client';
import { useSetAtom } from 'jotai';

type Props = QueryHookOptions<
  AllAssemblyTemplatesForFilterSideBarQuery,
  AllAssemblyTemplatesForFilterSideBarQueryVariables
>;

export const useSelectStructure = (options?: Props) => {
  const setAllAssemblyTemplates = useSetAtom(allAssemblyTemplates);
  const setSelectedAssemblyTemplateId = useSetAtom(selectedAssemblyTemplateId);
  const structureId = useGetStructureId();

  return useAllAssemblyTemplatesForFilterSideBarQuery({
    ...options,
    variables: {
      structureId,
      type: TemplateTypeEnum.Assembly,
    },
    fetchPolicy: 'cache-first',
    skip: !structureId,
    onCompleted: (response) => {
      options?.onCompleted?.(response);
      if (!response?.allTemplates) return;
      setAllAssemblyTemplates(response.allTemplates);
      const first = response?.allTemplates?.[0];
      setSelectedAssemblyTemplateId((prev) => {
        const existsInList = prev && response.allTemplates?.some((t) => t.id === prev);
        const next = !prev || !existsInList ? first?.id : prev;
        return next;
      });
    },
  });
};
